<form class="padding row center" novalidate [formGroup]="loginForm" (ngSubmit)="login()">
  <div class="column gap">
    <mat-form-field>
      <input matInput placeholder="Email" type="email" formControlName="email" name="email" required />
    </mat-form-field>

    <mat-form-field>
      <input
        matInput
        placeholder="{{ 'LoginComponent.password' | translate }}"
        type="password"
        formControlName="password"
        name="password"
        required
      />
    </mat-form-field>

    <mat-checkbox color="primary" formControlName="remember">
      {{ 'LoginComponent.rememberMe' | translate }}
    </mat-checkbox>

    <button type="submit" mat-raised-button color="primary" [disabled]="loginForm.invalid">
      {{ 'LoginComponent.login' | translate }}
    </button>
  </div>
</form>
